// Gestores (7-oct-2026): la pestaña «Gestión» de Analítica y los filtros de gestionados /
// propios / propietario de las pestañas Desempeño y Canales.
export const gestionAnalytics = {
  tab: "Gestão",
  tabRestricted: "Meu repasse",
  restrictedTitle: "Meu repasse",

  pageFilters: {
    ownership: "Acomodações",
    ownershipAll: "Administradas e próprias",
    ownershipManaged: "Só administradas",
    ownershipOwn: "Só próprias",
    owner: "Proprietário",
    allOwners: "Todos os proprietários",
  },

  views: {
    business: "Meu negócio",
    owners: "Proprietários",
    expenses: "Despesas",
  },

  filters: {
    listings: "Alojamentos",
    allListings: "Todos",
    someListings: "{count} alojamentos",
    owner: "Proprietário",
    allOwners: "Todos",
    attribution: "Contar reservas por",
    checkout: "Data de check-out",
    checkin: "Data de check-in",
    nights: "Noites do período",
    attributionHelp: "Por check-out é como se faz o repasse aos proprietários: a estadia já terminou.",
    attributionHelpLabel: "O que significa “Contar reservas por”",
    currency: "Moeda",
  },

  warnings: {
    otaEstimated:
      "{count} reserva com a comissão da OTA estimada por porcentagem: o canal não informou a real. | {count} reservas com a comissão da OTA estimada por porcentagem: o canal não informou a real.",
    noBreakdown:
      "{count} reserva sem detalhamento: todo o valor foi considerado hospedagem. | {count} reservas sem detalhamento: todo o valor foi considerado hospedagem.",
    outdatedBreakdown:
      "{count} reserva foi editada ou estendida depois de importada: foi usado o valor atual. | {count} reservas foram editadas ou estendidas depois de importadas: foi usado o valor atual.",
    otherCurrencies: "Há acomodações em outra moeda ({currencies}). Troque a moeda acima para vê-las.",
    noOwner:
      "{count} acomodação administrada não tem proprietário atribuído. | {count} acomodações administradas não têm proprietário atribuído.",
    assignOwners: "Atribuir proprietários",
  },

  states: {
    loadError: "Não foi possível carregar os dados de gestão.",
    forbidden: "Você não tem permissão para ver estas informações.",
    periodTooLong: "Escolha um período de no máximo dois anos.",
    retry: "Tentar de novo",
    noMovements: "Sem movimentação neste período",
  },

  empty: {
    title: "Você administra acomodações de outros proprietários?",
    text: "Indique em cada acomodação que você a administra para um proprietário e em quais condições: sua comissão, quem recebe o valor das reservas e como fica a limpeza. Aqui você verá quanto ganha e quanto cabe a cada proprietário.",
    point1: "Suas comissões, limpezas e despesas, com o seu lucro real",
    point2: "O que transferir ou cobrar de cada proprietário",
    point3: "O repasse de cada proprietário em PDF ou Excel",
    cta: "Configurar minhas acomodações",
  },

  period: {
    subtitle: "{period} · {attribution} · {granularity}",
    byCheckout: "reservas por data de check-out",
    byCheckin: "reservas por data de check-in",
    byNights: "noites do período",
    day: "por dia",
    week: "por semana",
    month: "por mês",
  },

  counts: {
    reservations: "{count} reserva | {count} reservas",
    nights: "{count} noite | {count} noites",
    units: "{count} acomodação | {count} acomodações",
    ownUnits: "{count} acomodação própria | {count} acomodações próprias",
    owners: "{count} proprietário | {count} proprietários",
  },

  business: {
    kpi: {
      managedGross: "Faturamento administrado",
      commissions: "Suas comissões",
      cleaning: "Limpezas",
      ownRevenue: "Receita das acomodações próprias",
      expenses: "Despesas",
      profit: "Lucro",
    },
    vatLine: "+ IVA {amount}",
    ofTotal: "do faturamento total",
    overManaged: "sobre o administrado",
    ofIncome: "da sua receita",
    margin: "de margem",
    chartTitle: "Receitas, despesas e lucro",
    chartA11y: "Gráfico das receitas, despesas e lucro do período",
    legend: {
      commissions: "Comissões",
      cleaning: "Limpezas",
      own: "Acomodações próprias",
      expenses: "Despesas",
      profit: "Lucro",
    },
    byCategory: "Despesas por categoria",
    category: "Categoria",
    amount: "Valor",
    noExpenses: "Sem despesas neste período",
    seeExpenses: "Ver despesas",
  },

  owners: {
    kpi: {
      gross: "Receita das reservas",
      ota: "Comissões das OTAs",
      cleaning: "Limpezas",
      commission: "Sua comissão + IVA",
      commissionRestricted: "Comissão do gestor + IVA",
      charged: "Despesas repassadas",
      net: "Líquido para proprietários",
      netRestricted: "Seu líquido",
    },
    ofGross: "da receita",
    collectedByYou: "recebido por você",
    collectedByManager: "recebido pelo seu gestor",
    commissionLine: "{commission} + IVA {vat}",
    otaLine: "{commission} + IVA {vat}",
    otaTitle: "Comissão das OTAs {commission} + IVA {vat}",
    commissionTitle: "Comissão {commission} + IVA {vat}",
    toTransfer: "A transferir aos proprietários",
    toCollect: "A cobrar dos proprietários",
    toTransferRestricted: "Seu gestor transfere a você",
    toCollectRestricted: "A pagar ao seu gestor",
    chartTitle: "Divisão da receita",
    chartA11y: "Gráfico da divisão da receita das reservas administradas",
    legend: {
      net: "Líquido proprietários",
      netRestricted: "Seu líquido",
      commissions: "Suas comissões",
      commissionsRestricted: "Comissão do gestor",
      ota: "Comissões das OTAs",
      cleaning: "Limpezas",
      other: "Taxas, cauções, IVA e despesas",
    },
    grossFooter: "Receita: {amount}",
    tableTitle: "Repasse por proprietário",
    tableTitleRestricted: "Detalhe do seu repasse",
    downloadAll: "Baixar tudo (PDF)",
    download: "Baixar (PDF)",
    downloading: "Baixando…",
    pdf: "PDF",
    excel: "Excel",
    exportError: "Não foi possível baixar o repasse.",
    cols: {
      owner: "Proprietário",
      reservations: "Reservas",
      gross: "Receita",
      ota: "OTA",
      cleaning: "Limpeza",
      commission: "Comissão + IVA",
      charged: "Despesas",
      net: "Líquido",
      balance: "Saldo",
      actions: "Downloads",
    },
    noOwner: "Sem proprietário atribuído",
    transfer: "Transferir {amount}",
    collect: "Cobrar {amount}",
    receive: "A receber {amount}",
    pay: "A pagar {amount}",
    collectionManager: "Recebe o gestor",
    collectionOwner: "Recebe o proprietário",
    total: "Total",
    expand: "Ver o detalhe de {name}",
    collapse: "Ocultar o detalhe de {name}",
    iban: "IBAN {iban}",
    showReservations: "Ver reservas ({count})",
    hideReservations: "Ocultar reservas",
    noData: "Não há reservas administradas neste período.",
    reservations: {
      checkIn: "Entrada",
      checkOut: "Saída",
      guest: "Hóspede",
      listing: "Acomodação",
      channel: "Canal",
      gross: "Receita",
      ota: "OTA",
      cleaning: "Limpeza",
      commission: "Comissão",
      vat: "IVA",
      net: "Líquido",
      direct: "Direta",
      estimated: "est.",
      estimatedHelp: "Estimada por porcentagem: o canal não informou a comissão real.",
      noBreakdown: "sem detalhamento",
      noBreakdownHelp: "A reserva não tem detalhamento: todo o valor foi considerado hospedagem.",
      complete: "Complete",
      completed: "Completed",
      completeHelp: "Fill in cleaning, the real OTA commission or the cleaning for this booking",
      manual: "manual",
      manualHelp: "OTA commission entered by hand for this booking.",
      loading: "Carregando reservas…",
      loadError: "Não foi possível carregar as reservas.",
      empty: "Não há reservas neste período.",
    },
    charged: {
      title: "Despesas repassadas ao proprietário",
      date: "Data",
      concept: "Descrição",
      listing: "Acomodação",
      amount: "Valor",
      general: "Geral",
    },
  },

  a11y: {
    views: "Seções de gestão",
  },
  // Liquidación por propietario: la cuenta y las columnas del PDF.
  liq: {
    precio: "Preço",
    comision: "Comissão OTA",
    tasas: "Taxas",
    limpieza: "Limpeza",
    honorarios: "Honorários",
    honorariosIva: "Honorários + IVA",
    neto: "Líquido proprietário",
    transfieres: "Transferes-lhe",
    tePaga: "Paga-te",
    recibes: "Recebes",
    pagas: "Pagas",
    netoPropietarios: "Líquido para proprietários",
    formula: "Receita = Preço − Comissão · Total = Receita − Taxas − Limpeza · Líquido = Total − Honorários − IVA. Igual ao PDF e ao Excel.",
    cols: {
      origen: "Origem",
      nombre: "Nome",
      entrada: "Entrada",
      salida: "Saída",
      precio: "Preço",
      noches: "Noites",
      comision: "Comissão",
      ingreso: "Receita",
      tasas: "Taxas",
      limpieza: "Limpeza",
      total: "Total",
      honorarios: "Honorários",
      iva: "IVA",
      neto: "Líquido",
    },
  },
};
